import { useState, useEffect, useCallback } from 'react';
import apiService, { parseGetAllUsersResponse } from '../services/api';

interface HubManager {
  userid: number;
  name: string;
  phoneNumber: string;
  hubid: number;
}

const useHubManagers = () => {
  const [hubManagers, setHubManagers] = useState<HubManager[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHubManagers = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const payload = {
        name: null,
        roleid: 7,
        hubid: null,
        userstatus: null,
        kycstatus: null,
        registrationdate: null,
        reporttype: "staff",
        pageNumber: 1,
        pageSize: 500,
      };

      const response = await apiService.getAllUsers(payload);
      const { items: responseData } = parseGetAllUsersResponse(response);

      const managers = responseData
        .filter((user: any) => user.userid && user.name)
        .map((user: any) => ({
          userid: user.userid,
          name: user.name || user.fullname || "",
          hubid: user.hubid,
          phoneNumber: user.phoneNumber || user.phonenumber || user.mobile || user.phone || ""
        }));
      
      setHubManagers(managers);
    } catch (err: any) {
      console.error('Error fetching hub managers:', err);
      setError(err.message || "Failed to fetch hub managers");
      setHubManagers([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHubManagers();
  }, [fetchHubManagers]);

  return { hubManagers, loading, error, refetch: fetchHubManagers };
};

export default useHubManagers;
